import React from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as ErrorIcon } from 'Assets/svg/crm-auth-error.svg';
import Button from 'Components/common/Button';
import HocPopupComponent from 'Components/common/hocPopupComponent';
import advSearchState from 'Stores/advSearch';
import './styles.scss';

const SalesforceAuthErrorPopup = observer(() => {
  const history = useHistory();

  return (
    advSearchState.showSalesforceAuthError && (
      <HocPopupComponent
        customClassName="sf-auth-error"
        showCloseIcon
        closeClick={() => {
          advSearchState.showSalesforceAuthError = false;
        }}
      >
        <ErrorIcon />
        <p className="title">Salesforce CRM Authorization</p>
        <p className="description">
          It appears that your Salesforce CRM connection is not working. Please
          disconnect and reconnect your Salesforce account before purchasing
          contacts
        </p>
        <Button
          className="blue"
          btnText="Go to Salesforce Settings"
          click={() => {
            advSearchState.showSalesforceAuthError = false;
            history.push('/integrations/salesforce/settings');
          }}
        />
        <p className="note">
          Need help? Contact{' '}
          <a href="mailto:success@adapt.io">success@adapt.io</a>
        </p>
      </HocPopupComponent>
    )
  );
});

export default SalesforceAuthErrorPopup;
